import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/help.svg';
import { Icon } from '../Icon/Icon';
export const HelpIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
